import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { GENERAL_ENQUETE_JSON_INPUT_TYPE, Question } from 'src/@types/generalEnquete';
import RHFTextField from 'src/components/react-hook-form/RHFTextField';
import { useValidator } from 'src/features/general/enquete-create/hooks/useValidator';
import { setQuestionItem } from 'src/features/general/enquete-create/store/enqueteCreateSlice';
import { QUESTIONITEM_SAVE_MODE } from 'src/generalConstants';
import { RootState, useDispatch, useSelector } from 'src/redux/store/index';
import { v1 } from 'uuid';
import DateValidationForm from './DateValidationForm';
import RequiredValidationForm from './RequiredValidationForm';

type QuestionTextFormProps = {
  methods: UseFormReturn;
  existingQuestion?: Question;
};

const QuestionDateRangeForm = ({ methods, existingQuestion }: QuestionTextFormProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const questionItem = useSelector((state: RootState) => state.enqueteCreate.questionItem);

  const { rulesCreateQuestionTitle } = useValidator(methods);

  useEffect(() => {
    if (existingQuestion) {
      dispatch(
        setQuestionItem({
          mode: QUESTIONITEM_SAVE_MODE.REFILL,
          currentInputType: GENERAL_ENQUETE_JSON_INPUT_TYPE.DATERANGE,
          value: existingQuestion.questionItem,
        }),
      );
    } else {
      if (!questionItem.length) {
        dispatch(
          setQuestionItem({
            mode: QUESTIONITEM_SAVE_MODE.ADD,
            currentInputType: GENERAL_ENQUETE_JSON_INPUT_TYPE.DATERANGE,
            value: [
              { id: v1(), label: '' },
              { id: v1(), label: '' },
            ],
          }),
        );
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <RHFTextField
            margin="normal"
            name="textQuestion"
            control={methods.control}
            fullWidth
            rows={2}
            multiline
            placeholder={t('enqueteCreate.inputQuestion')}
            rules={rulesCreateQuestionTitle}
            defaultValue={existingQuestion ? existingQuestion.title : ''}
          />
        </Grid>
      </Grid>

      <RequiredValidationForm methods={methods} existingQuestion={existingQuestion} />
      <DateValidationForm
        methods={methods}
        existingQuestion={existingQuestion}
        labelKey={'enqueteCreate.validation.dateRangeVisible'}
        textQuestionName={'textQuestion'}
      />
    </>
  );
};

export default QuestionDateRangeForm;
